import { Price, PriceInformation } from '@shared/models/price.model';
import { Image, SubscriptionBundleOption } from '../modules/mobilephone/models/mobilephone-search-item';
import { BackorderInfo } from '../modules/mobilephone/models/mobilephone-variant';
import { AmountPrice } from './price.model';

export interface AccessoryResponse {
  results: AccessoryItem[];
  totalCount: number;
}

export interface AccessoryItem {
  offeringId: string;
  productType: ProductTypes;
  latUpdate: Date;
  slug: string;
  groupSlug: string;
  name: string;
  priceInformation: PriceInformation;
  gtin: string;
  mainCategory: string;
  subCategory: string;
  manufacturer: string;
  image: Image;
  hardwareOfferingWithSubscriptionPrice: HardwareOfferingWithSubscriptionPrice;
  subscriptionBundleOptions: SubscriptionBundleOption[];
  priceFrom: number;
  keyInformation: string[];
  backorderInfo: BackorderInfo;
}

export interface HardwareOfferingWithSubscriptionPrice {
  offeringId: string;
  recommendedRetailPrice: Price;
  currentPrice: Price;
  expirationDate: Date;
  availableSubscriptions: SubscriptionForHardwareOffering[];
}

export interface SubscriptionForHardwareOffering {
  hardwareOfferingId: string;
  subscriptionOfferingId: string;
  subsidyId: string;
  hardwareOfferingPriceWithSubscription: AmountPrice;
  subscriptionMonthlyPrice: AmountPrice;
  subscriptionFullName: string;
  subscriptionName: string;
  subscriptionDataPerMonthInMb: number;
  bindingInfo: SubscriptionBindingInfo;
  upperAgeLimit?: number;
  lowerAgeLimit?: number;
  isAvailableWithEquipmentUpgrade: boolean;
}
export interface AccessoryFilterValues {
  searchTerm: string;
  manufacturers: string[];
  productTypes: string[];
  mainCategories: string[];
  subCategories: string[];
}

export interface SubscriptionBindingInfo {
  bindingPeriodInMonths: number;
  terminationFee: Price;
}

export interface AccessorySpecification {
  name: string;
  value: string;
}

export interface ExtendedAccessorySpecification {
  name: string;
  attributes: AccessorySpecification[];
}

export enum ProductTypes {
  Unknown = 'Unknown',
  Cellphone = 'Cellphone',
  CellphoneAccessory = 'CellphoneAccessory',
  Smartwatch = 'Smartwatch',
  MbbRouter = 'MbbRouter',
  MbbEquipment = 'MbbEquipment',
  MbbSubscription = 'MbbSubscription',
  Subscription = 'Subscription',
  DeliveryOption = 'DeliveryOption',
  VoiceSubscription = 'VoiceSubscription',
  M2MSubscription = 'M2MSubscription',
}
